import { useAuth } from "../Context/AuthContext";
import { useOptionalServiceContext } from "../Context/ServiceProvider";
import { SERVICES } from "../Context/serviceConstants";
import { ENTITY_PERMISSIONS } from "./entityPermissionMap";

// Plain, non-hook version of the same resolution algorithm — usable from a .map()/loop, where
// usePermission() itself can't be called (Rules of Hooks). ModulesSection.jsx and
// StatutoryCompliances.jsx both need to check a different entity per item in a loop; this is
// their single source of truth instead of each hand-copying this formula.
export function resolveModulePermission(moduleName, action, { normalizedRoles, hasEntityAccess, isBusinessContext }) {
  const mapping = ENTITY_PERMISSIONS[moduleName];
  const entityKey = (isBusinessContext && mapping?.businessEntityKey) || mapping?.entityKey;
  return normalizedRoles?.systemAdmin === true || hasEntityAccess(entityKey, action);
}

export const usePermission = (moduleName) => {
  const { hasEntityAccess, normalizedRoles } = useAuth();
  const serviceContext = useOptionalServiceContext();
  const isBusinessContext = serviceContext?.service === SERVICES.MY_BUSINESS;

  const can = (action) =>
    resolveModulePermission(moduleName, action, { normalizedRoles, hasEntityAccess, isBusinessContext });

  return {
    canRead: can("R"),
    canCreate: can("C"),
    canEdit: can("E"),
    canDelete: can("E"),
    canApprove: can("A"),
  };
};
